import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { connectionsManageMessages } from '../connections-manage-messages';
import { ConnectAlternative } from './connect-alternative';
import { ConnectAlternativesDialog } from './ConnectAlternativesDialog';

type Props = {
  platform: SocialPlatform;
  alternatives: ConnectAlternative[];
};

/**
 * Plain Conectar trigger that opens the connect-alternatives dialog.
 */
export function PlatformMultiConnect({ platform, alternatives }: Props) {
  const { $t } = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={platform.Icon()}
        onClick={() => setOpen(true)}
      >
        {$t(connectionsManageMessages.connect)}
      </Button>
      <ConnectAlternativesDialog
        open={open}
        onClose={() => setOpen(false)}
        platform={platform}
        alternatives={alternatives}
      />
    </>
  );
}
